import { FC, useState } from 'react';
import { toast } from 'sonner';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle 
} from '@/components/ui/dialog';
import { ManualVoucherForm } from '../ManualVoucherForm';
import { vouchersService } from '../../services/vouchers.service';
import { ManualVoucherData } from '../../types';

interface ManualVoucherModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (voucherId: string) => void;
}

export const ManualVoucherModal: FC<ManualVoucherModalProps> = ({ 
  isOpen, 
  onClose, 
  onSuccess 
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data: ManualVoucherData) => {
    setLoading(true);
    
    try {
      const response = await vouchersService.emitManualVoucher(data);
      
      if (response.success) {
        toast.success('Comprobante emitido exitosamente', {
          description: `ID: ${response.voucherId}`
        });
        
        // Llamar callback de éxito si está definido
        onSuccess?.(response.voucherId);
        
        // Cerrar modal
        onClose();
      } else {
        throw new Error('Error en la emisión del comprobante');
      }
    } catch (error) {
      console.error('Error al emitir comprobante:', error);
      toast.error('Error al emitir comprobante', {
        description: error instanceof Error ? error.message : 'Error desconocido'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[65vw] w-[65vw] max-h-[80vh] overflow-y-auto sm:max-w-[80vw] lg:max-w-[60vw] xl:max-w-[55vw]">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">
            Emisión Manual de Comprobantes
          </DialogTitle>
          <p className="text-gray-600 text-sm">
            Emita boletas y facturas manuales para situaciones de contingencia o ajustes
          </p>
        </DialogHeader>
        
        <div className="mt-4">
          <ManualVoucherForm 
            onSubmit={handleSubmit} 
            loading={loading}
            showCancelButton={false}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};